<template>
  <div id="content">
    <div class="container">
      <div class="content-image">
        <img src="@/assets/imgs/b7.jpg" alt="" />
      </div>
      <div class="content-detail">
        <div class="detail-title">集团介绍</div>
        <div class="detail-text">
          洋宇集团以自营品牌为主，集皮鞋、皮具、儿童用品的设计、开发、生产和销售为一体的时尚鞋服企业。公司非常重视产品的开发设计，致力于
          、生产和销售为一体的时尚鞋服企业。公司非常重视产品的开发设计，致力于打造引领时尚和科技的一流产品，在全球时尚中心如法国巴黎、意大利
          米兰设有时尚信息中心。公司在温州、上海、广州、成都分别设有研发机构。
          公司非常重视产品的开发设计，致力于打造引领时尚和科技的一流产品，在全球时尚中心如法国巴黎、意大利
          米兰设有时尚信息中心。
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>
    
<style scoped>
#content {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
#content .container {
  display: flex;
  justify-content: space-between;
  width: 1200px;
  padding: 87px 0 141px 0;
}

#content .container .content-image {
  width: 528px;
  height: 325px;
}

#content .container .content-image img {
  width: 528px;
  height: 325px;
}

#content .container .content-detail {
  margin-left: 80px;
  position: relative;
}

#content .container .content-detail .detail-title {
      position: relative;
  font-size: 26px;
  font-weight: bold;
}

#content .container .content-detail .detail-title::after {
  position: absolute;
  content:"";
  top: 42px;
  left: 0;
  width: 32px;
  height: 2px;
  background: #ff0000;
}

#content .container .content-detail .detail-text {
  margin-top: 35px;
  font-size: 18px;
  color: #333333;
  line-height: 30px;
  font-weight: 400;
}
</style>


// WEBPACK FOOTER //
// src/components/sub/Content.vue